import { Link, useParams } from "react-router-dom";
import MobileForm from "../../../../../../components/MobileForm";
import { makeStyles } from '@material-ui/core';
import { Box }  from '@material-ui/core';
import { useEffect, useState } from "react";
import useAPI from 'hooks/useAPI';
import useCustomer from 'hooks/useCustomer';

const useStyles = makeStyles({
  formButton: {
    width: '30px',
    background: '#6271CB',
    color: 'white',
    borderRadius: 5,
    display: 'block',
    textDecoration: 'none',
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 7,
    marginLeft: 20,
    marginRight: 20,
  }
});

export default function ShellLeakagePage3() {
  const styles = useStyles()
  const { version, appointmentId, enrollmentNumber } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);
  const [submissions, setSubmissions] = useState([]);
  const { customer } = useCustomer(enrollmentNumber);
  const api = useAPI();

  const getForms = () => {
    return api 
      .get(`/appointments/${appointmentId}/submissions`)
      .then(res => setSubmissions(res.data.submissions))
      .catch(err => console.log(err))
  };

  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  useEffect(() => {
    if(customer) {
      getForms();
    }
  }, [customer]);

  const targetIds = [
    "677c266977394b2a789eb06f",
    "677c268977394b2a789eb070",
    "677c269b77394b2a789eb072"
  ]

  const matchingSubmissionIds = submissions
    .filter(submission => targetIds.includes(submission.form._id))
    .map(submission => {
      // Extract the numeric page number from the form abbreviation (e.g., repairedAndReplacedPage3 -> 3)
      const match = submission.form.abbr.match(/Page(\d+)/i);
      const pageNumber = match ? parseInt(match[1], 10) : Infinity; // default to Infinity if no match
      return { ...submission, pageNumber };
  })
  .sort((a, b) => a.pageNumber - b.pageNumber); // Sort by page number

  return (
    <div>
      <MobileForm
        type="shellLeakagePage3"
        version={version}
        width={width}
        height={newHeight}
        useValidation={useValidation}
        background={background}
        fields={fields}
      />
      <Box display="flex" flexDirection="row">
        {matchingSubmissionIds.map(submission => (
          <Link
            key={submission._id}
            to={`/customers/${enrollmentNumber}/appointment/${appointmentId}/form/${submission.form.abbr}/${version}/${submission._id}`}
            className={styles.formButton}
          >
            {submission.pageNumber}
          </Link>
        ))}
      </Box>
    </div>
  );
};